module.exports = __webpack_public_path__ + "img/bike.8c26446f.svg";